import {
  ApCheckbox,
  ApSimpleDropdown,
  colors,
} from '@alixpartners/ui-components';
import styled from 'styled-components';

interface ICheckboxWrapperProps {
  disabled?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  border-bottom: 1px solid ${colors.grey3};
`;

export const Bottom = styled.div<{ isHide: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${({ isHide }) => (isHide ? 0 : 48)}px;
  border-bottom: ${({ isHide }) => (isHide ? 0 : 1)}px dashed ${colors.grey3};
  transition: height 0.3s;
  overflow: hidden;
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  font-weight: 500;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 16px;
  background-color: ${colors.grey3};
`;

export const SpaceBetweenDropdowns = styled.div`
  width: 8px;
`;

export const SpaceBetween = styled.div`
  font-size: 16px;
  color: ${colors.grey7};
  margin: 0 8px;
`;

export const CostSimpleDropdown = styled(ApSimpleDropdown)`
  margin-left: 8px;
`;

export const BreadcrumbText = styled.div`
  font-size: 16px;
  color: ${colors.grey8};
`;

export const BreadcrumbLargeText = styled.div`
  font-size: 23px;
  color: ${colors.grey8};
`;

export const BreadcrumbLink = styled.div`
  font-size: 16px;
  color: ${colors.grey5};
  cursor: pointer;
  &:hover {
    color: ${colors.green1};
  }
`;

export const CheckboxWrapper = styled.div<ICheckboxWrapperProps>`
  padding: 1px 6px 0 15px;

  span + span {
    text-transform: uppercase;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: ${({ disabled }) =>
      disabled ? `${colors.grey5}` : `${colors.grey8}`};
    padding-left: 16px !important;
    cursor: ${({ disabled }) => (disabled ? `not-allowed` : `pointer`)};
  }
`;

export const StyledCheckbox = styled(ApCheckbox)`
  min-width: 18px;
`;
